import { render, staticRenderFns } from "./BatchRent.vue?vue&type=template&id=5bf6e304&scoped=true"
import script from "./BatchRent.vue?vue&type=script&lang=js"
export * from "./BatchRent.vue?vue&type=script&lang=js"
import style0 from "./BatchRent.vue?vue&type=style&index=0&id=5bf6e304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6e304",
  null
  
)

export default component.exports